import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { FAQS } from "../../data";

export default function FAQAccordion() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <div className="mx-auto max-w-3xl divide-y divide-white/10 border-y border-white/10">
      {FAQS.map((f, i) => {
        const isOpen = openIdx === i;
        return (
          <div key={i} data-testid={`faq-item-${i}`}>
            <button
              onClick={() => setOpenIdx(isOpen ? -1 : i)}
              className="flex w-full items-center justify-between gap-6 py-6 text-left"
              data-testid={`faq-trigger-${i}`}
              aria-expanded={isOpen}
            >
              <span className="font-display text-lg font-medium tracking-tight md:text-xl">{f.q}</span>
              <motion.span
                animate={{ rotate: isOpen ? 45 : 0 }}
                transition={{ duration: 0.3 }}
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border ${
                  isOpen ? "border-blue-500 text-blue-400" : "border-white/15 text-slate-400"
                }`}
              >
                <Plus className="h-5 w-5" />
              </motion.span>
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                  className="overflow-hidden"
                >
                  <p className="pb-6 pr-16 leading-relaxed text-slate-400">{f.a}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
